import React from 'react';
import {Typography} from '~library/atoms/Typography';
import './Header.sass';

export const Header = ({title, extra, dark = false}) => (
  <div className="header">
    <Typography as="h1" variant="label2" color={dark ? 'charcoal' : 'pebble'}>
      {title}
    </Typography>
    <div className="header__extra">{extra}</div>
  </div>
);
